<template>
  <div class="text-diff-view">
    <span
      v-for="(seg, idx) in segments"
      :key="idx"
      :class="segmentClass(seg.type)">{{ seg.text }}</span>
  </div>
</template>

<script>
import { diffText } from '@/utils/textDiff'

export default {
  name: 'TextDiffView',
  props: {
    original: {
      type: String,
      default: ''
    },
    modified: {
      type: String,
      default: ''
    }
  },
  computed: {
    segments() {
      return diffText(this.original, this.modified)
    }
  },
  methods: {
    segmentClass(type) {
      if (type === 'delete') {
        return 'diff-del'
      }
      if (type === 'insert') {
        return 'diff-ins'
      }
      return 'diff-eq'
    }
  }
}
</script>

<style scoped>
.text-diff-view {
  font-size: 14px;
  line-height: 1.625;
  white-space: pre-wrap;
  word-break: break-word;
}

.diff-eq {
  color: #333;
}

.diff-del {
  padding: 0 2px;
  border-radius: 2px;
  background: #fecaca;
  color: #7f1d1d;
  text-decoration: line-through;
}

.diff-ins {
  padding: 0 2px;
  border-radius: 2px;
  background: #bbf7d0;
  color: #14532d;
}
</style>
